<div class="flex flex-row flex-nowrap w-full">
  <soft-search-input
    class="w-full"
    (debouncedSearchTermChange)="explorer().search($event, searchInput.options())"
    (optionsChange)="explorer().search(searchInput.searchTerm(), $event)"
    #searchInput>
  </soft-search-input>
  <div *ngIf="filterConfig || sortConfig"
       class="relative h-8 w-8 ml-2">
    <button class="flex flex-row justify-center items-center rounded bg-secondary-200 hover:bg-secondary-400 disabled:bg-secondary-200 h-full w-full"
            [disabled]="!explorer().source()?.length"
            [ngClass]="{'!bg-primary !hover:bg-primary-700 !text-primary-contrast': ((explorer().filterParams()?.length ?? 0) > 0) || explorer().sortParams()}"
            (click)="onOpenDialog()">
      <soft-icon name="fa-regular fa-bars-filter"></soft-icon>
    </button>
    @if (((explorer().filterParams()?.length ?? 0) > 0) || explorer().sortParams()) {
      <div class="soft-badge !fixed !top-auto !left-auto !right-auto !bottom-auto -mt-[2.275rem] ml-[1.2rem]">!</div>
    }
  </div>
</div>
